import React, { useEffect, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { Providers } from "@microsoft/mgt-element";

interface CustomSettings extends models.ISettings {
  allowPersonalizeVisuals?: boolean;
}

const MenuTestPage: React.FC = () => {
  const [token, setToken] = useState<string>("");

  const refreshToken = async () => {
    try {
      const access_token = await Providers.globalProvider.getAccessToken({
        scopes: ["https://analysis.windows.net/powerbi/api/.default"],
      });
      console.log(access_token);
      setToken(access_token);
    } catch (error) {
      console.error("Erro ao obter o token:", error);
    }
  };

  const saveToLocalStorage = (key: string, data: any) => {
    try {
      localStorage.setItem(key, JSON.stringify(data));
      console.log(`${key} salvo no Local Storage`);
    } catch (error) {
      console.error(`Erro ao salvar ${key} no Local Storage:`, error);
    }
  };

  const loadFromLocalStorage = (key: string) => {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error(`Erro ao carregar ${key} do Local Storage:`, error);
      return null;
    }
  };

  const applyPreferencesToReport = (preferences: any) => {
    console.log("Aplicando preferências:", preferences);
  };

  const handleReportLoaded = (event: CustomEvent) => {
    const embed = event.detail;

    if (embed && embed.bookmarksManager) {
      const bookmarksManager = embed.bookmarksManager;

      bookmarksManager
        .capture()
        .then((bookmark: any) => {
          console.log("Bookmark salvo:", bookmark);
          saveToLocalStorage("bookmarks", bookmark);
        })
        .catch((error: any) => {
          console.error("Erro ao salvar o bookmark:", error);
        });

      // Carregar preferências do Local Storage
      const preferences = loadFromLocalStorage("preferences");
      if (preferences) {
        applyPreferencesToReport(preferences);
      }
    } else {
      console.error("BookmarksManager não disponível.");
    }
  };

  const handleVisualRendered = async (event: CustomEvent) => {
    console.log("Visual Rendered:", event);
    const preferences = {};
    saveToLocalStorage("preferences", preferences);
  };

  useEffect(() => {
    const fetchPreferences = async () => {
      const preferences = loadFromLocalStorage("preferences");
      if (preferences) {
        applyPreferencesToReport(preferences);
      }
    };

    fetchPreferences();
    refreshToken();
  }, []);

  return (
    <div className="d-flex flex-column">
      <div className="d-flex powerbi-embed">
        <PowerBIEmbed
          embedConfig={{
            type: "report",
            id: "00cd366e-a931-4d5a-8296-aef8e25b2807",
            embedUrl:
              "https://app.powerbi.com/reportEmbed?reportId=00cd366e-a931-4d5a-8296-aef8e25b2807&groupId=2c92482f-9923-4835-871e-da1c72bd3328",
            accessToken: token,
            tokenType: models.TokenType.Aad,
            settings: {
              panes: {
                filters: { visible: true },
                pageNavigation: { visible: true },
              },

              allowPersonalizeVisuals: true, // Adicionando a propriedade personalizada
            } as CustomSettings,
          }}
          cssClassName="report-container"
          eventHandlers={
            new Map([
              ['loaded', function (event) { console.log(event, event?.type); }],
              ['rendered', function (event) { console.log(event, event?.type); }],
              ['error', function (event) { console.log(event, event?.type); }],
              ['dataSelected', (event) => console.log(event, event?.type)],
              ['pageChanged', (event) => console.log(event, event?.type)],
              ['visualRendered', (event) => console.log(event, event?.type)]
            ])
          }
        />
      </div>
    </div>
  );
};
 
export default MenuTestPage;